export async function enableGuardian(args) {
    const { spaceDapp, fnArgs, smartAccount } = args;
    const { signer } = fnArgs;
    if (!spaceDapp) {
        throw new Error('SpaceDapp is not available');
    }
    return spaceDapp.spaceOwner.enableGuardian({
        signer,
        overrideExecution: async ({ toAddress, calldata }) => {
            return smartAccount.sendUserOp({
                toAddress,
                callData: calldata,
                signer,
                spaceId: undefined,
                functionHashForPaymasterProxy: 'enableGuardian',
            });
        },
    });
}
export async function disableGuardian(args) {
    const { spaceDapp, fnArgs, smartAccount } = args;
    const { signer } = fnArgs;
    if (!spaceDapp) {
        throw new Error('SpaceDapp is not available');
    }
    return spaceDapp.spaceOwner.disableGuardian({
        signer,
        overrideExecution: async ({ toAddress, calldata }) => {
            return smartAccount.sendUserOp({
                toAddress,
                callData: calldata,
                signer,
                spaceId: undefined,
                functionHashForPaymasterProxy: 'disableGuardian',
            });
        },
    });
}
// this batches the enableGuardian and transferOwnership calls b/c the guardian is not re-enabled after transferring, and it's also not unique per space,
// so we our quick solution is to enable the guardian again after transferring
export async function transferOwnership(args) {
    const { spaceDapp, fnArgs, smartAccount } = args;
    const { signer, from, to, tokenId } = fnArgs;
    if (!spaceDapp) {
        throw new Error('SpaceDapp is not available');
    }
    const [enableGuardianToAddress, enableGuardianCalldata] = await spaceDapp.spaceOwner.enableGuardian({
        signer,
        overrideExecution: async ({ toAddress, calldata }) => [toAddress, calldata],
    });
    const [transferOwnershipToAddress, transferOwnershipCalldata] = await spaceDapp.spaceOwner.transferOwnership({
        signer,
        from,
        to,
        tokenId,
        overrideExecution: async ({ toAddress, calldata }) => [toAddress, calldata],
    });
    return smartAccount.sendUserOp({
        toAddress: [transferOwnershipToAddress, enableGuardianToAddress],
        callData: [transferOwnershipCalldata, enableGuardianCalldata],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'transferOwnership',
    });
}
